import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_COURSE_CLASS = requestConstantsMaker('GET_ALL_COURSE_CLASS');
export const GET_COURSE_CLASS = requestConstantsMaker('GET_COURSE_CLASS');
export const CREATE_COURSE_CLASS = requestConstantsMaker('CREATE_COURSE_CLASS');
export const UPDATE_COURSE_CLASS = requestConstantsMaker('UPDATE_COURSE_CLASS');
export const DELETE_COURSE_CLASS = requestConstantsMaker('DELETE_COURSE_CLASS');
export const GET_COURSE_CLASSES_FOR_SELECTION = requestConstantsMaker('GET_COURSE_CLASSES_FOR_SELECTION');
export const GET_COURSE_CLASS_FOR_DEFAULT_NEW_APPLICATION = requestConstantsMaker('GET_COURSE_CLASS_FOR_DEFAULT_NEW_APPLICATION');
export const GET_COURSE_CLASSES_FOR_COURSE_SCHEDULE = requestConstantsMaker('GET_COURSE_CLASSES_FOR_COURSE_SCHEDULE');
export const GET_COURSE_CLASS_FOR_COURSE_SCHEDULE = requestConstantsMaker('GET_COURSE_CLASS_FOR_COURSE_SCHEDULE');
/**** 20200217 ****/

export const GET_ALL_COURSE_CLASS_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_COURSE_CLASS_BY_SPECIFICATION');
export const GET_ALL_COURSE_CLASS_FOR_RESCHEDULE = requestConstantsMaker('GET_ALL_COURSE_CLASS_FOR_RESCHEDULE');
export const GET_COURSE_CLASS_BY_ID = requestConstantsMaker('GET_COURSE_CLASS_BY_ID');
export const GET_COURSE_CLASS_SCHEDULE_BY_SPECIFICATION = requestConstantsMaker('GET_COURSE_CLASS_SCHEDULE_BY_SPECIFICATION');
export const POST_CREATE_COURSE_CLASS = requestConstantsMaker('POST_CREATE_COURSE_CLASS');
export const PUT_UPDATE_COURSE_CLASS = requestConstantsMaker('PUT_UPDATE_COURSE_CLASS');
export const GET_COURSE_CLASS_FOR_NEW_APPLICATION = requestConstantsMaker('GET_COURSE_CLASS_FOR_NEW_APPLICATION');